import { Component, Input, OnInit } from '@angular/core';
import {
  TotalPriceCalculator,
  // tslint:disable-next-line:max-line-length
} from 'src/app/patient/components/patient-detail/sections/integratedcare/direct-order-edit/direct-order-invoice-data/totalPrice-calculator';
import { GrossPriceCalculator } from '../gross-price-calculator';

import { CrossTherapyArticleLineViewModel } from './../../../../../../../business/cross-therapy/cross-therapy-article-line-view-model';

@Component({
  selector: 'itl-cross-therapy-billing-summary-line',
  templateUrl: './cross-therapy-billing-summary-line.html',
  styleUrls: ['./cross-therapy-billing-summary-line.scss'],
})
export class CrossTherapyBillingSummaryLine implements OnInit {
  @Input() articleLine: CrossTherapyArticleLineViewModel;

  public hidden = false;

  public ngOnInit() {
    if (this.articleLine.quantity < 1) {
      this.hidden = true;
    }
    this.articleLine.totalPrice = TotalPriceCalculator.calculateArticleTotal(
      this.articleLine.price,
      this.articleLine.quantity,
      this.articleLine.packagingUnitQuantity
    );
  }

  public updatePrice() {
    this.articleLine.totalPrice = this.articleLine.totalPrice.replace(/[^0-9,]/g, '');
    if (this.articleLine.totalPrice === '') {
      this.articleLine.totalPrice = '0';
    }
    this.articleLine.price = GrossPriceCalculator.updateSinglePrice(
      this.articleLine.quantity,
      this.articleLine.totalPrice,
      this.articleLine.packagingUnitQuantity
    );
  }
}
